import {Directive, EventEmitter, Input, input, Output} from "@angular/core";
import {TransactionWorkflowSub} from "../../../../_models/WorkflowTargets/transaction-workflow-sub";
import {GetTypes} from "../../../../../../helpers/enum-helpers";

@Directive()
export class TransactionWorkflowSubComponent<T extends TransactionWorkflowSub> {
  constructor(t: Record<string, string | number>) {
    this.targets = GetTypes(t);
  }

  @Input() model!: T;
  @Input() last: boolean = false;
  @Output() onRemove = new EventEmitter<T>();

  /**
   * CSS selector of the container every `<ng-select>` in this row (and in the leaf picker it renders) is
   * portaled into — ng-select's `[appendTo]`, Bug #236.
   *
   * It is threaded down from the page instead of being hardcoded here, for two reasons that are both
   * failure modes rather than preferences:
   *
   *  * `appendTo` **throws** (`appendTo selector … did not found any parent element`) when its selector matches
   *    nothing, and it takes the whole page down with it, not just the dropdown. These rows are generic —
   *    hardcoding the workflows page's box would turn any future reuse into a crash.
   *  * the target has to be a POSITIONED, non-clipping box, which only the host page knows.
   *
   * The default `''` is deliberately falsy: ng-select's `_appendDropdown()` returns early on a falsy value, so
   * an un-hosted row keeps today's inline rendering rather than throwing. The `[appendTo]` binding is still
   * present in the template, so `NgSelectScrollAwareDirective` attaches either way and the coupling
   * "portaled ⇒ scroll-aware" cannot be broken by forgetting a wire-up.
   */
  readonly panelAppendTo = input('');

  protected remove() {
    this.onRemove.emit(this.model);
  }

  protected targets: string[];
}
